import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiMail, FiLock, FiArrowRight, FiShield } from 'react-icons/fi';
import { AuthContext } from '../../context/AuthContext';
import './AdminLogin.css';

const AdminLogin = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, isAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/admin');
    }
  }, [isAuthenticated, navigate]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const result = await login(formData.email, formData.password);
    
    if (result.success) {
      navigate('/admin');
    } else {
      const errorMessage = result.message || 'Erreur de connexion';
      if (errorMessage.includes('ECONNREFUSED') || errorMessage.includes('Proxy error')) {
        setError('Le serveur backend n\'est pas démarré. Veuillez démarrer le serveur backend (port 5000) avant de vous connecter.');
      } else {
        setError(errorMessage);
      }
    }
    
    setLoading(false);
  };

  return (
    <div className="admin-login-ux">
      <div className="login-background">
        <div className="login-gradient"></div>
        <div className="login-pattern"></div>
      </div>
      
      <div className="login-container-ux">
        <motion.div
          className="login-card-ux"
          initial={{ opacity: 0, y: 30, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ duration: 0.6, ease: [0.4, 0, 0.2, 1] }}
        >
          <div className="login-header-ux">
            <div className="login-logo-wrapper">
              <div className="login-logo">
                <FiShield className="logo-icon" />
              </div>
            </div>
            <h1 className="login-title">VirtualHand</h1>
            <h2 className="login-subtitle">Administration</h2>
            <p className="login-description">
              Connectez-vous pour accéder au panneau d'administration
            </p>
          </div>

          {error && (
            <motion.div
              className="alert alert-error-ux"
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
            >
              <FiShield className="alert-icon" />
              {error}
            </motion.div>
          )}

          <form onSubmit={handleSubmit} className="login-form-ux">
            <div className="form-group-ux">
              <label htmlFor="email" className="form-label-ux">
                <FiMail className="label-icon" />
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="admin@virtualhand.com"
                autoComplete="email"
                className="form-input-ux"
              />
            </div>

            <div className="form-group-ux">
              <label htmlFor="password" className="form-label-ux">
                <FiLock className="label-icon" />
                Mot de passe
              </label>
              <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
                placeholder="••••••••"
                autoComplete="current-password"
                className="form-input-ux"
              />
            </div>

            <motion.button
              type="submit"
              className="login-button-ux"
              disabled={loading}
              whileHover={{ scale: 1.02, boxShadow: "0 12px 32px rgba(45, 80, 22, 0.4)" }}
              whileTap={{ scale: 0.98 }}
            >
              {loading ? (
                <span>Connexion...</span>
              ) : (
                <>
                  <span>Se connecter</span>
                  <FiArrowRight className="button-arrow" />
                </>
              )}
            </motion.button>
          </form>
        </motion.div>
      </div>
    </div>
  );
};

export default AdminLogin;
